import debounce from 'lodash.debounce';

export function hamburger() {
    let lastScrollTop = 0;
    let lockedScrollY = 0;
    const hamburger = document.querySelector('#js-burger');
    const menuMobileClose = document.querySelector('#js-menu-mobile-close');
    const categories = document.querySelector('#js-categories');
    const logo = document.querySelector('.header__logo');
    const header = document.querySelector('.header');
    const box = document.querySelector('.header__box');
    const lines = document.querySelectorAll('.header__line');
    const searchButton = document.querySelector('#headerSearchToggle');
    const menuSearch = document.querySelector('#headerMenuSearch');
    const menuSearchInput = document.querySelector('#headerMenuSearchInput');
    const menuSearchClose = document.querySelector('#headerMenuSearchClose');
    const menuSearchResults = document.querySelector(
        '#headerMenuSearchResults'
    );
    const headerMenuSearchForm = document.querySelector('#headerMenuSearch');
    const headerSearchMobile = document.querySelector('#headerSearchMobile');
    const headerResultsMobile = document.querySelector('#headerResultsMobile');
    const isExternalSearchEnabled =
        headerMenuSearchForm?.dataset.externalSearch === '1';

    const menuContainer = document.querySelector('.header__menu-container');
    const iconCategories = document.querySelector('.header__categories');

    const mobileFixedMenu = document.querySelector('[data-mobile-fixed-menu]');

    function lockBodyScroll() {
        if (document.body.classList.contains('menu-scroll-locked')) return;

        lockedScrollY = window.scrollY || window.pageYOffset || 0;
        document.body.classList.add('menu-scroll-locked');
        document.body.style.position = 'fixed';
        document.body.style.top = `-${lockedScrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
    }

    function unlockBodyScroll() {
        if (!document.body.classList.contains('menu-scroll-locked')) return;

        document.body.classList.remove('menu-scroll-locked');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        document.body.style.overflow = '';

        window.scrollTo(0, lockedScrollY);
    }

    function syncBodyScrollLock() {
        const shouldLock =
            (hamburger && hamburger.classList.contains('is-active')) ||
            (categories && categories.classList.contains('is-active')) ||
            (box && box.classList.contains('header__box--active'));

        if (shouldLock) {
            lockBodyScroll();
            return;
        }

        unlockBodyScroll();
    }

    if (mobileFixedMenu) {
        window.addEventListener('scroll', event => {
            const { scrollY } = window;
            if (scrollY > 100) {
                mobileFixedMenu.classList.add('scrolled');
            } else {
                mobileFixedMenu.classList.remove('scrolled');
            }
        });
    }

    hamburger.addEventListener('click', function () {
        if (hamburger.classList.contains('is-active')) {
            hamburger.classList.remove('is-active');
            logo.classList.remove('header__logo--active');
            header.classList.remove('header--active');
            box.classList.remove('header__box--active');
            lines.forEach(line => {
                line.classList.remove('header__line--active');
            });
            syncBodyScrollLock();
        } else {
            hamburger.classList.add('is-active');
            logo.classList.add('header__logo--active');
            header.classList.add('header--active');
            box.classList.add('header__box--active');
            lines.forEach(line => {
                line.classList.add('header__line--active');
            });
            syncBodyScrollLock();
        }
    });

    menuMobileClose.addEventListener('click', function () {
        hamburger.classList.remove('is-active');
        logo.classList.remove('header__logo--active');
        header.classList.remove('header--active');
        box.classList.remove('header__box--active');
        lines.forEach(line => {
            line.classList.remove('header__line--active');
        });
        syncBodyScrollLock();
    });

    categories.addEventListener('click', function () {
        if (categories.classList.contains('is-active')) {
            categories.classList.remove('is-active');
            box.classList.remove('header__box--active');
            header.classList.remove('header--active');
            menuContainer.classList.remove('header__menu-container--active');
            iconCategories.classList.remove('header__categories--active');
            syncBodyScrollLock();
        } else {
            categories.classList.add('is-active');
            box.classList.add('header__box--active');
            header.classList.add('header--active');
            menuContainer.classList.add('header__menu-container--active');
            iconCategories.classList.add('header__categories--active');
            syncBodyScrollLock();
        }
    });

    window.addEventListener('scroll', event => onWindowScroll(event));
    window.addEventListener('click', event => onClickOutside(event));

    setWindowResizeAssets();

    if (searchButton)
        searchButton.addEventListener('click', event => onSearchToggle(event));
    if (menuSearchInput) {
        menuSearchInput.addEventListener('keyup', event =>
            onMenuSearchInput(event)
        );
        menuSearchInput.addEventListener('keydown', event =>
            onMenuSearchKeydown(event)
        );
    }
    if (menuSearchClose)
        menuSearchClose.addEventListener('click', event =>
            onMenuSearchClose(event)
        );

    if (headerMenuSearchForm)
        headerMenuSearchForm.addEventListener('submit', event =>
            onMenuSearchSubmit(event)
        );

    if (headerSearchMobile && !isExternalSearchEnabled)
        headerSearchMobile.addEventListener('keyup', event =>
            onMenuSearchInputMobile(event)
        );

    const getSearchResults = debounce(searchResults, 400);

    function onClickOutside(event) {
        const { target } = event;
        if (!header.contains(target)) {
            hamburger.classList.remove('is-active');
            categories.classList.remove('is-active');
            box.classList.remove('header__box--active');
            header.classList.remove('header--active');
            menuContainer.classList.remove('header__menu-container--active');
            iconCategories.classList.remove('header__categories--active');
            lines.forEach(line => {
                line.classList.remove('header__line--active');
            });
            syncBodyScrollLock();
        }
    }

    function onWindowScroll(event) {
        const { scrollY } = window;
        if (scrollY > lastScrollTop) {
            header.classList.add('header--scrolled');
        } else {
            header.classList.remove('header--scrolled');
        }

        if (scrollY <= 0) header.classList.remove('header--scrolled');
        lastScrollTop = scrollY;
    }

    function setWindowResizeAssets() {
        onWindowResize();
        window.addEventListener('resize', event => onWindowResize(event));
    }

    function onWindowResize(event) {
        const { innerHeight } = window;
        const { clientHeight } = header;
        const root = document.querySelector(':root');
        root.style.setProperty('--window-height', `${innerHeight}px`);
        root.style.setProperty('--header-height', `${clientHeight}px`);
    }

    function onSearchToggle(event) {
        if (!menuSearch) return;

        if (!isExternalSearchEnabled) {
            event.preventDefault();
            menuSearch.classList.toggle('active');
            if (menuSearch.classList.contains('active') && menuSearchInput) {
                menuSearchInput.focus();
            }
            return;
        }

        // Pierwsze kliknięcie otwiera pole, kolejne wysyła formularz.
        if (!menuSearch.classList.contains('active')) {
            event.preventDefault();
            menuSearch.classList.add('active');
            if (menuSearchInput) {
                menuSearchInput.focus();
            }
            return;
        }

        if (menuSearchInput && menuSearchInput.value.trim().length < 2) {
            event.preventDefault();
            menuSearchInput.focus();
        }
    }

    function onMenuSearchClose(event) {
        if (!menuSearch) return;
        menuSearch.classList.remove('active');
        menuSearch.classList.remove('filled');
        if (menuSearchResults) {
            menuSearchResults.innerHTML = '';
        }
    }

    function onMenuSearchSubmit(event) {
        if (!isExternalSearchEnabled) {
            event.preventDefault();
            const phrase = menuSearchInput?.value?.trim() || '';
            if (phrase.length >= 3) {
                menuSearch.classList.add('filled');
                getSearchResults(phrase);
            }
            return;
        }

        if (!menuSearchInput || menuSearchInput.value.trim().length < 2) {
            event.preventDefault();
            if (menuSearchInput) {
                menuSearchInput.focus();
            }
        }
    }

    function onMenuSearchKeydown(event) {
        if (!isExternalSearchEnabled || event.key !== 'Enter') {
            return;
        }

        event.preventDefault();

        const phrase = menuSearchInput?.value?.trim() || '';
        if (phrase.length < 2) {
            menuSearchInput?.focus();
            return;
        }

        if (headerMenuSearchForm) {
            if (typeof headerMenuSearchForm.requestSubmit === 'function') {
                headerMenuSearchForm.requestSubmit();
            } else {
                headerMenuSearchForm.submit();
            }
        }
    }

    function onMenuSearchInput(event) {
        const { currentTarget } = event;
        const { value } = currentTarget;

        if (value.length > 0) {
            currentTarget.classList.add('filled');
        } else {
            currentTarget.classList.remove('filled');
        }

        if (isExternalSearchEnabled) {
            menuSearch?.classList.remove('filled');
            if (menuSearchResults) {
                menuSearchResults.innerHTML = '';
            }
            return;
        }

        if (value.length >= 3) {
            menuSearch.classList.add('filled');
            getSearchResults(value.trim());
        } else {
            menuSearch.classList.remove('filled');
            if (menuSearchResults) {
                menuSearchResults.innerHTML = '';
            }
        }
    }

    function onMenuSearchInputMobile(event) {
        const { currentTarget } = event;
        const phrase = currentTarget.value.trim();

        if (!headerResultsMobile) {
            return;
        }

        if (phrase.length >= 3) {
            headerResultsMobile.classList.add('active');
            getSearchResults(phrase);
        } else {
            headerResultsMobile.classList.remove('active');
            headerResultsMobile.innerHTML = '';
        }
    }

    function searchResults(phrase) {
        if (isExternalSearchEnabled || !phrase) {
            return;
        }

        const endpoint = `${home_url}/wp-json/articles/v1/search?phrase=${encodeURIComponent(
            phrase
        )}`;

        fetch(endpoint, {
            method: 'GET',
            credentials: 'same-origin',
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Search request failed');
                }
                return response.json();
            })
            .then(data => {
                const articlesHtml = data?.articles_html || '';

                if (menuSearchResults) {
                    menuSearchResults.innerHTML = articlesHtml;
                }

                if (headerResultsMobile) {
                    headerResultsMobile.innerHTML = articlesHtml;
                }
            })
            .catch(() => {
                if (menuSearchResults) {
                    menuSearchResults.innerHTML = '';
                }
                if (headerResultsMobile) {
                    headerResultsMobile.innerHTML = '';
                }
            });
    }
}
